// extracted by mini-css-extract-plugin
export default {"auxTag":"Heading_auxTag__2kR38"};